import { render } from "./FormTabungan.vue?vue&type=template&id=18deb2ff"
import script from "./FormTabungan.vue?vue&type=script&lang=js"
export * from "./FormTabungan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__